import React, { useState } from 'react';

// PasswordInput — a password field with a working Show/Hide toggle. Drop-in
// replacement for a raw <input type="password">; all input props pass
// through. Used on every auth surface so the toggle is consistent and
// actually works (the old per-page versions were missing or inconsistent).
export default function PasswordInput({ className = '', ...props }) {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <input
                {...props}
                type={show ? 'text' : 'password'}
                className={`pr-16 ${className}`}
            />
            <button
                type="button"
                tabIndex={-1}
                // preventDefault on mousedown keeps focus in the field so the
                // click always registers (without it, the blur + browser
                // password-manager overlay can swallow the click). z-10 keeps
                // our toggle above any browser-injected reveal/key icon.
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setShow(s => !s)}
                aria-label={show ? 'Hide password' : 'Show password'}
                className="absolute right-2 top-1/2 -translate-y-1/2 z-10 text-xs font-semibold text-slate-500 hover:text-slate-700 bg-white px-2 py-1 rounded">
                {show ? 'Hide' : 'Show'}
            </button>
        </div>
    );
}
